import { render, staticRenderFns } from "./HotelDetail.vue?vue&type=template&id=fa5d2ce6&scoped=true"
import script from "./HotelDetail.vue?vue&type=script&lang=js"
export * from "./HotelDetail.vue?vue&type=script&lang=js"
import style0 from "./HotelDetail.vue?vue&type=style&index=0&id=fa5d2ce6&prod&lang=scss&scoped=true"
import style1 from "./HotelDetail.vue?vue&type=style&index=1&id=fa5d2ce6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa5d2ce6",
  null
  
)

export default component.exports